import swal from "sweetalert";
import { BACKEND } from "../context/backend";

export function getClientesService(authTokens) {
  return fetch(BACKEND + "/api/clientes/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function updateClienteService(id, cliente, authTokens) {
  const body = JSON.stringify(cliente);


  return fetch(BACKEND + `/api/cliente/${id}`, {

    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Cliente editado", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

export function deleteClienteService(id, authTokens) {
  // Funcion que se encarga de eliminar a un cliente pasandole su id.
  return fetch(`${BACKEND}/api/cliente/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function createClienteService(cliente, authTokens) {
  const body = JSON.stringify(cliente);

  return fetch(BACKEND + "/api/clientes/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Cliente creado!", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}
